import React from "react";

function Wifi() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="44"
            height="44"
            fill="none"
            viewBox="0 0 44 44"
        >
            <path
                fill="#DF8D46"
                d="M15.788 22.666c1.724-1.696 3.802-2.544 6.234-2.544s4.498.848 6.192 2.544l-1.752 1.794c-1.222-1.224-2.71-1.834-4.462-1.834-1.752 0-3.238.612-4.462 1.836l-1.75-1.796zm3.544 3.588c.722-.722 1.612-1.084 2.668-1.084s1.946.362 2.668 1.084L22 28.922l-2.668-2.668zM12.2 19.122c2.724-2.696 5.998-4.046 9.82-4.046s7.082 1.348 9.78 4.046l-1.794 1.794c-2.224-2.196-4.892-3.294-8.006-3.294s-5.782 1.098-8.006 3.294L12.2 19.122z"
            ></path>
            <path
                stroke="#DF8D46"
                strokeDasharray="10 10"
                strokeWidth="2"
                d="M1 1H43V43H1z"
            ></path>
        </svg>
    );
}

export default Wifi;
